import { styled } from '@linaria/react';

interface Props {
  size?: number;
  status: 'playing' | 'idle';
}

function MorphingPlayStopIcon({ status, ...props }: Props) {
  const d =
    status === 'idle'
      ? 'M 7 4 L 20 12 L 20 12 L 7 20 Z'
      : 'M 5 5 L 19 5  L 19 19 L 5 19 Z';

  return (
    <Svg aria-hidden="true" viewBox="0 0 24 24">
      <path d={d} />
    </Svg>
  );
}

const Svg = styled.svg`
  display: block;
  width: 24px;
  height: 24px;
  fill: none;
  stroke: currentColor;
  stroke-width: 2px;
  stroke-linecap: round;
  stroke-linejoin: round;

  path {
    transition: d 200ms;
  }
`;

export default MorphingPlayStopIcon;
